// extracted by mini-css-extract-plugin
module.exports = {"galleryHeader":"styles_galleryHeader__3b5kL","galleryActionsBox__right":"styles_galleryActionsBox__right__3gvZg","galleryActionsBox__left":"styles_galleryActionsBox__left__1cQzA"};